module.exports = __webpack_public_path__ + "static/media/Frame.f2ee7bd0.png";